// Core Imports
import React, {useState} from "react";
import {NavLink} from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import {connect} from "react-redux";
import {Formik, Form, Field, ErrorMessage} from "formik";
import * as Yup from "yup";

import {ToastContainer, toast} from 'react-toastify';

// Custom Imports
import logo from "../../public/assets/images/logo.png";
import * as ACTIONS from "./../../store/actions";
import Spinner from "./../../components/Spinner/Spinner";
import axios from "./../../axios";

// formik form validation
const formikValidateSchema = Yup.object().shape({
    // password: Yup.string().required("Password is required."),
    // password_confirmation: Yup.string().required("Password Confirmation is required."),

    password: Yup.string().required("Password is required.").min(6, "Password should 6 digits."),
    password_confirmation: Yup.string().when("password", {
        is: val => (val && val.length > 0 ? true : false),
        then: Yup.string().oneOf(
            [Yup.ref("password")],
            "Both password need to be the same"
        )
    })
});

class StudentProfile extends React.Component {
    state = {
        errors: null,
        showpass: true,
        showpassconfirm: true,
        formSubmitting: false,
        formikInitialValues: null,
    };

    showpass() {
        this.setState({
            showpass: !this.state.showpass,
        })
    }

    showpassconfirm() {
        this.setState({
            showpassconfirm: !this.state.showpassconfirm,
        })
    }

    componentDidMount() {
        const props = this.props;
        const studentProfileData = props.student_signup_data;
        console.log(
            "SignupStudentDetailStep.js === componentDidMount == props = ",
            {props, studentProfileData}
        );
        this.setState({
            formikInitialValues: {
                password: studentProfileData.password,
                password_confirmation: studentProfileData.password_confirmation,
            },
        });
    }

    clearErrorsHandler = () => {
        this.setState({errors: null});
    };

    formSubmitHandler = (data) => {
        console.log({data});
        this.setState({formSubmitting: true});
        const signUpData = {
            student_profile: this.props.student_signup_data.student_profile,
            school_profile: this.props.student_signup_data.school_profile,
            password: data.password,
            password_confirmation: data.password_confirmation,
        };
        axios
            .post("/student-signup", signUpData)
            .then((res) => {
                console.log("student-signup == res = ", {res});
                const errors = res.data.errors;
                if (errors && (errors.password || errors.password_confirmation)) {
                    window.scrollTo(0, 0);
                    this.setState((oldState) => {
                        return {
                            errors: errors,
                            formSubmitting: false,
                        };
                    });
                    return;
                } else {
                    const updateSignupData = {
                        ...this.props.student_signup_data,
                        ["password"]: data.password,
                        ["password_confirmation"]: data.password_confirmation,
                    };
                    this.props.setStudentSignUpData({
                        student_profile: {},
                        school_profile: {},
                        password: null,
                        password_confirmation: null
                    });
                    // alert("Signup Completed");
                    this.setState({formSubmitting: false});
                    this.props.goToLogin()
                    toast.success('Successfully Signup! Please check Email for verification your account.', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: false,
                        draggable: true,
                        progress: undefined,
                    });
                }
            })
            .catch((err) => {
                if (err.response) {
                    // client received an error response (5xx, 4xx)
                    console.log("Password Step Request - Error - Response")
                } else if (err.request) {
                    // client never received a response, or request never left
                    console.log("Password Step Request - Error - Request")

                } else {
                    // anything else
                    console.log("Password Step Request - Error - Else")
                }

                // Retry Request
                toast.error(err.message)
                // Retry Request End
                console.log("student-signup == err = ", {err});
                this.setState({formSubmitting: false});
            });
    };

    render() {

        const {formSubmitting, errors, formikInitialValues, showpass, showpassconfirm} = this.state;
        return (
            <React.Fragment>
                <div className="account-wrap signup">
                    <div className="logo">
                        <a href="javascript:void(0)" onClick={this.props.goToLogin}>
                            <img src={logo} alt=""/>
                        </a>
                    </div>
                    <div className="container position-relative">
                        <div className="row">
                            <div className="col-sm-7 offset-sm-5">
                                <div className="account-form-wrap form-signup">
                                    <div className="account-title">
                                        <h3>Create Student Profile</h3>
                                        <p>Set Account Password.</p>
                                    </div>
                                    {errors && (
                                        <div
                                            className="alert alert-danger alert-dismissible fade show pb-0"
                                            role="alert"
                                            style={{opacity: "0.7"}}
                                        >
                                            <ul>
                                                {Object.keys(errors).map((key) => (
                                                    <li key={key}>{errors[key][0]}</li>
                                                ))}
                                            </ul>
                                            <button
                                                type="button"
                                                className="close"
                                                data-dismiss="alert"
                                                aria-label="Close"
                                                onClick={this.clearErrorsHandler}
                                            >
                                                <span aria-hidden="true">&times;</span>
                                            </button>
                                        </div>
                                    )}
                                    <Formik
                                        initialValues={{password: "", password_confirmation: ""}}
                                        validationSchema={formikValidateSchema}
                                        onSubmit={(data) => {
                                            this.formSubmitHandler(data);
                                        }}
                                    >
                                        {({
                                              values,
                                              errors,
                                              touched,
                                              isValid,
                                              setFieldTouched,
                                              setFieldValue,
                                          }) => (
                                            <Form>
                                                <div className="form-floating">
                                                    <div className="form-row">
                                                        <div className="form-group col-sm-12">
                                                            <div
                                                                className={
                                                                    showpass
                                                                        ? "passwordContainer show"
                                                                        : "passwordContainer"
                                                                }
                                                            >
                                <span
                                    className="showPasswordIcon"
                                    onClick={() => {
                                        this.showpass();
                                    }}
                                >
                                  <i className="far fa-eye-slash"> </i>
                                </span>
                                                                <label>Password*</label>
                                                                <Field
                                                                    type="password"
                                                                    name="password"
                                                                    className="form-control"
                                                                />
                                                            </div>
                                                            <div
                                                                className={
                                                                    showpass
                                                                        ? "passwordContainer"
                                                                        : "passwordContainer show"
                                                                }
                                                            >
                                <span
                                    className="showPasswordIcon"
                                    onClick={() => {
                                        this.showpass();
                                    }}
                                >
                                  <i className="far fa-eye"></i>
                                </span>
                                                                <label>Password*</label>
                                                                <Field
                                                                    type="text"
                                                                    name="password"
                                                                    className="form-control"
                                                                />
                                                            </div>
                                                            <ErrorMessage name="password">
                                                                {(msg) => (
                                                                    <span className="invalid-feedback d-block">
                                    {msg}
                                  </span>
                                                                )}
                                                            </ErrorMessage>
                                                        </div>
                                                    </div>
                                                    <div className="form-row">

                                                        <div className="form-group col-sm-12">
                                                            <div
                                                                className={
                                                                    showpassconfirm
                                                                        ? "passwordContainer show"
                                                                        : "passwordContainer"
                                                                }
                                                            >
                                <span
                                    className="showPasswordIcon"
                                    onClick={() => {
                                        this.showpassconfirm();
                                    }}
                                >
                                  <i className="far fa-eye-slash"> </i>
                                </span>
                                                                <label>Confirm Password*</label>
                                                                <Field
                                                                    type="password"
                                                                    name="password_confirmation"
                                                                    className="form-control"
                                                                />
                                                            </div>
                                                            <div
                                                                className={
                                                                    showpassconfirm
                                                                        ? "passwordContainer"
                                                                        : "passwordContainer show"
                                                                }
                                                            >
                                <span
                                    className="showPasswordIcon"
                                    onClick={() => {
                                        this.showpassconfirm();
                                    }}
                                >
                                  <i className="far fa-eye"></i>
                                </span>
                                                                <label>Confirm Password*</label>
                                                                <Field
                                                                    type="text"
                                                                    name="password_confirmation"
                                                                    className="form-control"
                                                                />
                                                            </div>
                                                            <ErrorMessage name="password_confirmation">
                                                                {(msg) => (
                                                                    <span className="invalid-feedback d-block">
                                    {msg}
                                  </span>
                                                                )}
                                                            </ErrorMessage>
                                                        </div>
                                                    </div>
                                                    <div className="form-row">
                                                        {!formSubmitting && (
                                                            <button
                                                                type="submit"
                                                                disabled={
                                                                    (values.password &&
                                                                        values.password.length < 6) ||
                                                                    values.password !=
                                                                    values.password_confirmation
                                                                }
                                                                className="btn btn-round btn-secondary"
                                                            >
                                                                Signup
                                                            </button>
                                                        )}
                                                        {formSubmitting && <Spinner/>}
                                                    </div>
                                                    <div className="form-row">
                                                        <a href="javascript:void(0);" onClick={this.props.back}>
                                                            Back
                                                        </a>
                                                    </div>
                                                    <div className="form-row">
                                                        <em>
                                                            Already have an account?{" "}
                                                            <a href="javascript:void(0)" onClick={this.props.goToLogin}>
                                                                Login
                                                            </a>
                                                        </em>
                                                    </div>
                                                </div>
                                            </Form>
                                        )}
                                    </Formik>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        student_signup_data: state.authR.student_signup_data,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setStudentSignUpData: (payload) =>
            dispatch(ACTIONS.setStudentSignupData(payload)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(StudentProfile);
